import { Locale } from "../Locale.js";

export const inquiryId = {
	[Locale.cs]: "poptavka",
	[Locale.en]: "inquiry",
	[Locale.sk]: "poptavka",
};
